import * as Icons from '@ant-design/icons';
import { Card, DatePicker, Flex, Form, Input, Typography } from 'antd';
import { PreviewCertificate } from 'components/certificates/PreviewCertificate';
import { FieldsetTitle } from 'components/professor_area/FieldsetTitle';
import { FormItemCol } from 'components/professor_area/FormItemCol';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useCertificateStore } from '../../certificate.store';
import { PrintControlSection } from './PrintControlSection';
import { ShippingInfoSection } from './ShippingInfoSection';

export const TabCertificateInfo = () => {
  const { certificate } = useCertificateStore();
  const [form] = Form.useForm();

  // Função para desabilitar datas futuras
  const disabledDate = (current: dayjs.Dayjs) => current && current.isAfter(dayjs(), 'day');

  useEffect(() => {
    if (certificate) {
      const formValues: any = {
        ...certificate,
        issued_at: dayjs(certificate.issued_at),
        registered_at: dayjs(certificate.registered_at)
      };

      if (certificate.last_shipment) {
        if (certificate.last_shipment.sent_by_regulator_at) {
          formValues.sent_by_regulator_at = dayjs(certificate.last_shipment.sent_by_regulator_at);
        }
        if (certificate.last_shipment.received_by_secretary_at) {
          formValues.received_by_secretary_at = dayjs(certificate.last_shipment.received_by_secretary_at);
        }
        if (certificate.last_shipment.tracking_code) {
          formValues.tracking_code = certificate.last_shipment.tracking_code;
        }
        if (certificate.last_shipment.posted_at) {
          formValues.posted_at = dayjs(certificate.last_shipment.posted_at);
        }
      }

      form.setFieldsValue(formValues);
    }
  }, [certificate, form]);

  return (
    <Form form={form}>
      <fieldset className="mb-6">
        <FieldsetTitle
          title="Informações do certificado"
          icon={Icons.HddOutlined}
        />

        <div className="ml-7">
          <FormItemCol label="Data de expedição" name="issued_at">
            <DatePicker disabled format="DD/MM/YYYY" disabledDate={disabledDate} />
          </FormItemCol>
          <FormItemCol label="Data de registro" name="registered_at">
            <DatePicker disabled format="DD/MM/YYYY" disabledDate={disabledDate} />
          </FormItemCol>
          <FormItemCol label="Número de registro" name="registration_number">
            <Input disabled />
          </FormItemCol>
        </div>
      </fieldset>

      <fieldset className="mb-6">
        <Flex justify="space-between" align="center" className="mb-6">
          <FieldsetTitle
            title="Assinaturas"
            icon={Icons.HighlightOutlined}
            className="mb-0"
          />
        </Flex>
        <div className="ml-7">
          <FormItemCol label="Modelo" name={['signature_partner', 'name']}>
            <Input disabled />
          </FormItemCol>
          <FormItemCol
            label="Assinatura frente 1"
            name={['signature_partner', 'front_signature', 'name']}
          >
            <Input disabled />
          </FormItemCol>
          <FormItemCol
            label="Assinatura verso"
            name={['signature_partner', 'back_signature', 'name']}
          >
            <Input disabled />
          </FormItemCol>
          <FormItemCol
            label="Assinatura verso registro"
            name={['signature_partner', 'record_back_signature', 'name']}
          >
            <Input disabled />
          </FormItemCol>
        </div>
      </fieldset>

      <fieldset className="mb-8">
        <FieldsetTitle
          title="Pré Visualização"
          icon={Icons.FolderViewOutlined}
        />
        <Card size="small" className="bg-neutral-100">
          <Flex gap={16} justify="stretch" align="stretch">
            {certificate?.signature_partner?.front_signature && (
              <Flex vertical gap={8}>
                <Typography.Text strong>Frente</Typography.Text>
                <PreviewCertificate
                  type="front"
                  signaturePartner={certificate?.signature_partner}
                />
              </Flex>
            )}

            {certificate?.signature_partner?.back_signature &&
              certificate?.signature_partner?.record_back_signature && (
                <Flex vertical gap={8}>
                  <Typography.Text strong>Verso</Typography.Text>
                  <PreviewCertificate
                    type="back"
                    signaturePartner={certificate?.signature_partner}
                  />
                </Flex>
              )}
          </Flex>
        </Card>
      </fieldset>

      <PrintControlSection certificate={certificate} form={form} />

      <ShippingInfoSection certificate={certificate} form={form} />

    </Form>
  );
};
